var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.224121,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3F46AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3343_8787",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.22412,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3343_8787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 24.2241V21.2241C7 20.6741 7.19583 20.2033 7.5875 19.8116C7.97917 19.42 8.45 19.2241 9 19.2241H10V17.2241C10 16.6741 10.1958 16.2033 10.5875 15.8116C10.9792 15.42 11.45 15.2241 12 15.2241H15V13.2241H14C13.45 13.2241 12.9792 13.0283 12.5875 12.6366C12.1958 12.245 12 11.7741 12 11.2241V8.22412C12 7.67412 12.1958 7.20329 12.5875 6.81162C12.9792 6.41995 13.45 6.22412 14 6.22412H18C18.55 6.22412 19.0208 6.41995 19.4125 6.81162C19.8042 7.20329 20 7.67412 20 8.22412V11.2241C20 11.7741 19.8042 12.245 19.4125 12.6366C19.0208 13.0283 18.55 13.2241 18 13.2241H17V15.2241H20C20.55 15.2241 21.0208 15.42 21.4125 15.8116C21.8042 16.2033 22 16.6741 22 17.2241V19.2241H23C23.55 19.2241 24.0208 19.42 24.4125 19.8116C24.8042 20.2033 25 20.6741 25 21.2241V24.2241C25 24.7741 24.8042 25.245 24.4125 25.6366C24.0208 26.0283 23.55 26.2241 23 26.2241H19C18.45 26.2241 17.9792 26.0283 17.5875 25.6366C17.1958 25.245 17 24.7741 17 24.2241V21.2241C17 20.6741 17.1958 20.2033 17.5875 19.8116C17.9792 19.42 18.45 19.2241 19 19.2241H20V17.2241H12V19.2241H13C13.55 19.2241 14.0208 19.42 14.4125 19.8116C14.8042 20.2033 15 20.6741 15 21.2241V24.2241C15 24.7741 14.8042 25.245 14.4125 25.6366C14.0208 26.0283 13.55 26.2241 13 26.2241H9C8.45 26.2241 7.97917 26.0283 7.5875 25.6366C7.19583 25.245 7 24.7741 7 24.2241ZM14 11.2241H18V8.22412H14V11.2241ZM9 24.2241H13V21.2241H9V24.2241ZM19 24.2241H23V21.2241H19V24.2241Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon);
export default __webpack_public_path__ + "static/media/integration_icon.f47877f8070b919279b288eea2df6a8f.svg";
export { ForwardRef as ReactComponent };